// Simple Solution - OLD
(() => {
  const mainContent = document.querySelector('#MainContent');

  document.addEventListener('DOMContentLoaded', () => {
    // Select both inputs
    const idInputElement = document.querySelector('input[name="id"]');
    const giveMeTheVariantInputElement = document.querySelector('input[name="givemethevariant"]');

    if (idInputElement && giveMeTheVariantInputElement) {
      // Function to synchronize the values
      function syncVariantId() {
        giveMeTheVariantInputElement.value = idInputElement.value;

        window.eko?.gallery?.setVariant(giveMeTheVariantInputElement.value);

        mainContent.dispatchEvent(new CustomEvent('variant:update', {
          detail: {
            variantId: giveMeTheVariantInputElement.value,
          }
        }));

        // console.log('Synchronized variant ID:', giveMeTheVariantInputElement.value);
      }

      // Synchronize initially
      syncVariantId();

      // Listen for changes on the id input and synchronize
      idInputElement.addEventListener('change', syncVariantId);
    } else {
      console.log('One or both inputs (id, givemethevariant) not found.');
    }
  });
})();

// Update variant labels
(() => {
  function updateVariantDisplayName(evt) {
    const target = evt.target.closest('label') || evt.target;
    const selectorWrapper = target.closest('.selector-wrapper');

    if (!selectorWrapper) {
      return;
    }

    const variantNameDisplay = selectorWrapper.querySelector('.variant-name-display');

    if (!variantNameDisplay) {
      return;
    }

    variantNameDisplay.textContent = target.textContent;
  }

  document.querySelectorAll('.product__selectors .selector-wrapper').forEach((selectorWrapper) => {
    const labels = selectorWrapper.querySelectorAll('label');

    if (!labels.length) {
      return;
    }

    labels.forEach(label => label.addEventListener('click', updateVariantDisplayName));
  });
})();

// Move Compare
(() => {
  const compareBlock = document.querySelector('product-modal.custom-compare-popup');

  if (!compareBlock) {
    return;
  }

  const fieldset = compareBlock.nextElementSibling;

  if (!fieldset || !fieldset.classList.contains('simple-product__block--lines')) {
    compareBlock.remove();
    return;
  }

  const titleHolder = fieldset.querySelector('legend .radio__legend__label--text');

  if (!titleHolder) {
    return;
  }

  compareBlock.classList.remove('block-padding');

  titleHolder.appendChild(compareBlock);
})();

// Variants images
(() => {
  const section = document.querySelector('[data-section-type="product"]');

  if (!section) {
    return;
  }

  if (!section.querySelector("[data-product-variants]")) {
    return;
  }

  const productThumbs = section.querySelector('.product__thumbs');

  function updateImages(evt) {
    if (!evt.detail?.variant.featured_media) {
      return;
    }

    section.querySelectorAll('.product__slide').forEach((slide) => {
      slide.style.display = 'none';
    });

    section.querySelectorAll('.product__thumb').forEach((thumb) => {
      thumb.style.display = 'none';
      thumb.classList.remove('is-active');
    });

    let firstFound = false;
    section
      .querySelectorAll(
        `[data-media-group="${evt.detail.variant.featured_media.id}"], [data-media-group="universal"]`
      )
      .forEach((figure) => {
        const slide = figure.closest('.product__slide');

        slide.style.display = '';

        const mediaId = slide.dataset.mediaId;

        if (!mediaId || !productThumbs) {
          return;
        }

        const thumb = productThumbs.querySelector(`.product__thumb__link[data-media-id="${mediaId}"]`)?.closest('.product__thumb');

        if (!thumb) {
          return;
        }

        thumb.style.display = '';

        if (!firstFound) {
          thumb.classList.add('is-active');
          firstFound = true;
        }
      });
  }

  section.addEventListener('theme:variant:change', updateImages);
})();

// Trigger initial update
(() => {
  const section = document.querySelector('[data-section-type="product"]');

  if (!section) {
    return;
  }

  // Sometimes the theme doesn't fire a default variant change
  const input = section.querySelector('radio-swatch input:checked') || section.querySelector('.radio__button input:checked');

  if (!input) {
    return;
  }

  input.dispatchEvent(new Event('change'));
})();

// Open accordions
(() => {
  const accordions = document.querySelectorAll('details.accordion');

  function openAccordions() {
    accordions.forEach((accordion) => {
      if (!accordion.open) {
        const summary = accordion.querySelector('summary');

        if (!summary) {
          return;
        }

        const summaryTextContent = summary.textContent.trim().toLocaleLowerCase();

        if (document.documentElement.clientWidth < 768) {
          if (summaryTextContent === 'features') {
            summary.click();
          }
        } else if (summaryTextContent === 'features' || summaryTextContent === 'what\'s included') {
          summary.click();
        }
      }
    });
  }

  document.querySelectorAll('a[href="#features-desktop"], a[href="#features-mobile"]').forEach((item) => {
    item.addEventListener('click', openAccordions);
  });
})();